/**
 * Diagramma va davomat ranglarining YAGONA manbai — spec
 * `2026-09-17-hisobotlar-analitika-design.md` §2.1 (17.09 foydalanuvchi
 * qarori: 5 holat rangi + neytral, BUTUN ILOVADA).
 *
 * ⚠️ **Qiymatlar o'lchangan** (dataviz `validate_palette.js`, light:
 * eng yomon qo'shni CVD ΔE 9,2, oddiy ko'rish ΔE 16,3). «Yaqin» rangga
 * siljitish tekshiruvni bekor qiladi — `palette.test.ts` ularni AYNAN
 * pinlaydi.
 *
 * ⚠️ **Relief qoidasi:** `uzrli` (`#1baf7a`) oq fonda 2,74:1 — shu rang
 * bilan chizilgan segment yonida HAR DOIM raqamli yorliq yoki legendada
 * qiymat bo'ladi.
 *
 * ⚠️ **Trend yo'nalishi rang bilan berilmaydi** — strelka + ishora.
 *
 * ⚠️ **Komponentlarda `holatVar()` ishlating, hex EMAS** — dark rejim
 * `chart-theme.css` dagi `[data-theme="dark"]` bloki orqali ishlaydi.
 * `light`/`dark` hex qiymatlari faqat CSS o'zgaruvchisi ishlamaydigan
 * joylar (masalan, eksport) va drift testi uchun. `chart-theme.css`
 * bu qiymatlarning nusxasi va `palette.test.ts` tengligini pinlaydi.
 */
export type HolatRangi = "kelgan" | "kechikkan" | "ertaKetgan" | "uzrli" | "kelmagan" | "neytral";

export interface HolatRangQiymati {
	light: string;
	dark: string;
	cssVar: string;
}

export const HOLAT_RANGLARI: Record<HolatRangi, HolatRangQiymati> = {
	kelgan: { light: "#2a78d6", dark: "#3987e5", cssVar: "--chart-kelgan" },
	kechikkan: { light: "#4a3aa7", dark: "#9085e9", cssVar: "--chart-kechikkan" },
	ertaKetgan: { light: "#eb6834", dark: "#d95926", cssVar: "--chart-erta-ketgan" },
	uzrli: { light: "#1baf7a", dark: "#199e70", cssVar: "--chart-uzrli" },
	/** Kelmagan / ruxsatsiz / yuqori xavf. */
	kelmagan: { light: "#d03b3b", dark: "#e66767", cssVar: "--chart-kelmagan" },
	/** Dam, ma'lumotsiz — rang bilan ma'no bermaydigan element. */
	neytral: { light: "#8a929e", dark: "#6b7380", cssVar: "--chart-neytral" },
};

/** `"var(--chart-kelgan)"` — inline `style` va SVG `fill`/`stroke` uchun. */
export function holatVar(h: HolatRangi): string {
	return `var(${HOLAT_RANGLARI[h].cssVar})`;
}

/**
 * Ketma-ket (sequential) ko'k ramp — issiqlik xaritasi va zichlik uchun.
 * Birinchi qadam — «nol», fonga yaqin.
 */
export const SEQUENTIAL_BLUE: readonly string[] = [
	"#f3f3f0",
	"#cde2fb",
	"#9ec5f4",
	"#6da7ec",
	"#3987e5",
	"#256abf",
	"#1c5cab",
	"#104281",
	"#0d366b",
];

/**
 * `value` ni `[0, max]` oralig'ida ramp qadamiga aylantiradi.
 *
 * ⚠️ Noldan katta har qiymat KAMIDA 1-qadam oladi — aks holda kichik,
 * lekin mavjud sanoq «bo'sh» katak bilan bir xil ko'rinardi.
 * `max <= 0`, manfiy yoki `NaN` → birinchi qadam.
 */
export function sequentialStep(value: number, max: number): string {
	const oxirgi = SEQUENTIAL_BLUE.length - 1;

	if (!(value > 0 && max > 0)) {
		return SEQUENTIAL_BLUE[0] as string;
	}

	const qadam = Math.min(oxirgi, Math.max(1, Math.round((value / max) * oxirgi)));
	return SEQUENTIAL_BLUE[qadam] as string;
}

/**
 * `attendance_status` enum qiymati → holat rangi.
 *
 * ⚠️ `davom_etmoqda` — «kelgan» (xodim ishda), `dam` — neytral.
 */
export const ATTENDANCE_STATUS_RANG: Record<string, HolatRangi> = {
	kelgan: "kelgan",
	kechikkan: "kechikkan",
	// biome-ignore lint/style/useNamingConvention: backend status enum qiymati aynan shu
	erta_ketgan: "ertaKetgan",
	uzrli: "uzrli",
	kelmagan: "kelmagan",
	dam: "neytral",
	// biome-ignore lint/style/useNamingConvention: backend status enum qiymati aynan shu
	davom_etmoqda: "kelgan",
};
